module.exports = __webpack_public_path__ + "img/Communication.fbed0827.svg";